module.exports = __webpack_public_path__ + "img/logo-narradores.9fd646b4.png";